/**
 * Includes the secondary menu list entries shown on the very left side.
 * Secondary list entries are shown in the menu section below the separator.
 */

import {List} from '@mui/material'
import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import {NavLink} from 'react-router-dom'
import {useStyles} from "./GameNavItems.css";


const GameNavItemsSecondary = () => {
    const classes = useStyles()

    return (
        <List>
            <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive} to={"/common/about"}>
                <ListItemIcon>
                    <InfoIcon />
                </ListItemIcon>
                About
            </ListItem>
            <ListItem button component={NavLink} activeClassName={classes.active} className={classes.inactive} to={"/common/help"}>
                <ListItemIcon>
                    <HelpIcon />
                </ListItemIcon>
                Help
            </ListItem>
        </List>
    )
}

export default GameNavItemsSecondary
